<template>
  <section class="height-100-p">
    <el-table
      :data="loads.shipmentTracking.list"
      v-loading="loads.shipmentTracking.loadingSearch"
      id="shipmentTracking-data-list"
      size="mini"
      tooltip-effect="dark"
      sortable
      class="dark-blue-table"
      :empty-text="$t('common.notAbleToFindRecords')"
      @sort-change="handleSortChange"
      stripe
    >
      <el-table-column
        prop="consigneeName"
        :label="$t('shipmentTracking.consigneeName')"
        :min-width="5"
        align="left"
        header-align="center"
        sortable="custom">
        <template slot-scope="scope">
          <el-tooltip v-if="scope.row.consigneeName" class="item" effect="dark" :content="scope.row.consigneeName" placement="top">
            <span> {{ scope.row.consigneeName }} </span>
          </el-tooltip>
          <span v-else>
            <receiving-detail-dialog :currentRow="scope.row"/>
          </span>
        </template>
      </el-table-column>
      <el-table-column
        prop="numberOfUnits"
        :label="$t('shipmentTracking.numberOfUnits')"
        :min-width="5"
        align="center"
        sortable="custom">
      </el-table-column>
      <el-table-column
        prop="shipDate"
        :label="$t('shipmentTracking.shipDate')"
        :min-width="5"
        align="center"
        sortable="custom">
        <template slot-scope="scope">
          <el-tooltip class="item" effect="dark" :content="scope.row.shipDate" placement="top">
            <span> {{ scope.row.shipDate | moment(dateDisplayFormat) }} </span>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column
        prop="eta"
        :label="$t('shipmentTracking.eta')"
        :min-width="5"
        align="center"
        sortable="custom">
        <template slot-scope="scope">
          <span v-if="scope.row.hideEta">
            <span v-if="!scope.row.delivery">
              {{ $t('shipmentTracking.hideEta') }}
            </span>
          </span>
          <span v-else>
            {{ scope.row.eta | moment(dateTimeDisplayFormat) }}
          </span>
        </template>
      </el-table-column>
      <el-table-column
        prop="delivery"
        :label="$t('shipmentTracking.delivered')"
        :min-width="5"
        align="center"
        sortable="custom">
        <template slot-scope="scope">
          <span>
            {{ scope.row.delivery | moment(dateTimeDisplayFormat) }}
          </span>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination-footer" v-show="loads.shipmentTracking.total > 0">
      <span class="el-pagination__total" slot>
        <span class="el-pagination__title" slot>{{ $t('shipmentTracking.totalLabel') }}</span>
           {{ loads.shipmentTracking.total }}
      </span>
      <el-pagination
        @size-change="handleSearchChangeLimit"
        :page-sizes="sizes"
        :page-size="loads.shipmentTracking.actualFilters.rows"
        :current-page.sync="loads.shipmentTracking.actualFilters.page"
        @current-change="handleSearchChangePage"
        :total="loads.shipmentTracking.total"
        layout="slot, sizes, prev, pager, next, jumper"
      >
      </el-pagination>
    </div>
  </section>
</template>

<script>
import { mapGetters } from 'vuex';
import constants from '@/utils/constants';
import ReceivingDetailDialog from './components/ReceivingDetailDialog';

export default {
  name: 'ShipmentTrackingSummarySection',
  components: { ReceivingDetailDialog },
  computed: {
    ...mapGetters(['loads']),
    dateDisplayFormat() {
      return constants.DATES.DEFAULT_DISPLAY_FORMAT;
    },
    dateTimeDisplayFormat() {
      return constants.DATE_TIME.DEFAULT_DISPLAY_FORMAT;
    }
  },
  data() {
    return {
      sizes: constants.TABLES.DEFAULT_LIMIT_SIZES
    };
  },
  methods: {
    handleSortChange({ prop, order }) {
      this.$store.dispatch('loads/searchShipmentTracking', { orderField: prop, orderDirection: constants.TABLES.ORDER_DIRECTION[order] });
    },
    handleSearchChangeLimit(val) {
      this.$store.dispatch('loads/searchShipmentTracking', { rows: val, page: constants.TABLES.DEFAULT_PAGE });
    },
    handleSearchChangePage(val) {
      this.$store.dispatch('loads/searchShipmentTracking', { page: val });
    }
  }
};
</script>
<style rel="stylesheet/scss" lang="scss">
#shipmentTracking-data-list {
  .el-table__empty-text {
      line-height: 15px;
      width: 100%;
  }
}
.mobile {
  .app-view-container {
    margin: 15px 0px;
  }
  .pagination-footer .el-pagination__total {
    top: 5px;
  }
  .el-pagination {
    padding-top: 25px;
  }
  .app-view-title {
    margin-top: 30px;
    margin-left: 15px;
  }
  .el-dialog {
    width: 100% !important;
  }
  .el-dialog__body {
    padding: 20px 5px;
  }
}
</style>
